// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Scrollbar, A11y, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/autoplay'; // Ensure Autoplay CSS is imported if needed
import './_collection-list.scss';


// -------------------------------------
// Hooks
// -------------------------------------
$(function() {
    function updateButtonStates($playButton, $pauseButton, isPlaying) {
        $playButton.toggleClass('hidden', isPlaying);
        $pauseButton.toggleClass('hidden', !isPlaying);
    }

    $(".carousel--collection-list").each(function(index, element) {
        var $this = $(this);
        const enableChevron = $this.attr("data-chevron");
        const navigation = (enableChevron === 'true') ? {
            nextEl: ".collection-list-btn-next-" + index,
            prevEl: ".collection-list-btn-prev-" + index
        } : {};
        const mobileSlidesPerview = (enableChevron === 'true') ? 1 : 1.2;

        // Generate unique class for each feature collection slider
        $this.addClass("collection-list-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.collection-list').find(".swiper-scrollbar").addClass("collection-list-swiper-scrollbar-" + index);
        $this.parents('.collection-list').find(".swiper-button-next").addClass("collection-list-btn-next-" + index);
        $this.parents('.collection-list').find(".swiper-button-prev").addClass("collection-list-btn-prev-" + index);

        // Initialize Swiper
        var swiper = new Swiper(".collection-list-instance-" + index, {
            modules: [Navigation, Scrollbar, Autoplay],
            slidesPerView: mobileSlidesPerview,
            spaceBetween: 20,
            observer: true,
            observeParents: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true, // Stop autoplay on interaction (clicks, swipes, etc.)
                pauseOnMouseEnter: false   // Do not pause on mouse enter
            },
            breakpoints: {
                680: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },
            scrollbar: {
                el: ".collection-list-swiper-scrollbar-" + index,
                draggable: true,
                hide: false
            },
            navigation: navigation
        });

        // Play/Pause functionality
        var $playButton = $this.parents('.collection-list').find('.play');
        var $pauseButton = $this.parents('.collection-list').find('.pause');

        function updateButtonStates() {
            if (swiper.autoplay.running) {
                $playButton.addClass('hidden');
                $pauseButton.removeClass('hidden');
            } else {
                $playButton.removeClass('hidden');
                $pauseButton.addClass('hidden');
            }
        }

        // Update button states initially
        updateButtonStates();

        // Event listeners for play/pause buttons
        $playButton.on('click', function() {
            swiper.autoplay.start();
            updateButtonStates();
        });

        $pauseButton.on('click', function() {
            swiper.autoplay.stop();
            updateButtonStates();
        });

        // Stop autoplay on any interaction (clicks, swipes, etc.)
        $this.on('mousedown keydown', function() {
            swiper.autoplay.stop();
            updateButtonStates();
        });

         // Listen for the Swiper 'autoplay' event to ensure button states are synced
         swiper.on('autoplayStart', function() {
            updateButtonStates();
        });
        
        swiper.on('autoplayStop', function() {
            updateButtonStates();
        });
    });
});
